var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.appName === 'FlipPay')?[_c('div',{staticClass:"site-logo self-center"},[_c('img',{attrs:{"src":_vm.flipLogo,"alt":"Flippay"}})])]:(_vm.appName === 'Rello')?[_c('div',{staticClass:"site-logo self-center"},[_c('img',{attrs:{"src":_vm.relloLogo,"alt":"Rello"}})])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }